import { useTranslation } from 'react-i18next';
import { BackHeader } from '@/components/BackHeader';
import { ContactsView } from '@/features/contacts/ContactsView';

export function ContactsPage() {
  const { t } = useTranslation();
  return (
    <div>
      <BackHeader title={t('contacts.title')} />
      <ContactsView />
    </div>
  );
}
